import React from 'react';
import { useNavigate } from 'react-router-dom';
import styles from './MovieList.module.css';

const MovieList = (props) => {
  const navigate = useNavigate();

  // Filter out empty or null objects
  const validMovies = (props.movies || []).filter(
    (movie) => movie && Object.keys(movie).length > 0
  );

  if (validMovies.length === 0) {
    return <div>No movies to display</div>;
  }

  return (
    <div className={styles.movieListContainer}>
      {validMovies.map((movie) => (
        <div
          key={movie.id}
          className={styles.movieCard}
          onClick={() => navigate(`/movie/${movie.id}`)}
        >
          <img
            src={movie.default_thumb?.src}
            alt={movie.title}
            className={styles.movieThumbnail}
          />
          <div className={styles.movieInfo}>
            <h5 className={styles.movieTitle}>{movie.title}</h5>
            <p className={styles.movieViews}>{movie.views} views</p>
          </div>
        </div>
      ))}
    </div>
  );
};

export default MovieList;
